/**
 * useChurchInfo Hook
 *
 * Fetches church information using URQL query.
 * Replaces legacy graphql() call in ChurchPage.
 */

import { useQuery } from "urql";

// =============================================================================
// QUERY DOCUMENT
// =============================================================================

const ChurchInfoDocument = `
  query ChurchInfo {
    churchInfo {
      id
      title
      imageUrl
      welcomeText
      scheduleText
      address
      mapUrl
      parkingText
      phone
      email
      companyName
      companyDetails
      usefulChats {
        label
        url
      }
      isActive
    }
  }
`;

// =============================================================================
// TYPES
// =============================================================================

export interface UsefulChat {
  label: string;
  url: string;
}

export interface ChurchInfo {
  id: string;
  title: string | null;
  imageUrl: string | null;
  welcomeText: string | null;
  scheduleText: string | null;
  address: string | null;
  mapUrl: string | null;
  parkingText: string | null;
  phone: string | null;
  email: string | null;
  companyName: string | null;
  companyDetails: string | null;
  usefulChats: UsefulChat[];
  isActive: boolean;
}

interface ChurchInfoQueryResult {
  churchInfo: ChurchInfo | null;
}

// =============================================================================
// HOOK
// =============================================================================

export function useChurchInfo() {
  const [result, reexecute] = useQuery<ChurchInfoQueryResult>({
    query: ChurchInfoDocument,
  });

  return {
    info: result.data?.churchInfo ?? null,
    isLoading: result.fetching,
    error: result.error,
    refetch: reexecute,
  };
}
